import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { GoogleReview, PlaceDetails } from '../models/GoogleReview.model';

@Injectable({
  providedIn: 'root'
})
export class GoogleReviewsService {
  // Replace with your actual Place ID
  private readonly PLACE_ID = 'ChIJqezbcZY9iYgRDa4XmLrFfg4'; //chelsea placeId
  // private readonly PLACE_ID = 'ChIJ-x8-p7sjiYgRedbboX5FZhg'; //pelham placeId
  
  constructor(private http: HttpClient) {}

  /**
   * Fetches reviews from Google Places API
   * Note: For production, you should call your NestJS backend instead of directly calling Google API
   * to avoid exposing your API key and handle CORS issues
   */
  getReviews(): Observable<GoogleReview[]> {
    // Option 1: Direct API call (requires CORS handling and exposes API key)
    // const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${this.PLACE_ID}&fields=reviews,rating,user_ratings_total,name&key=${environment.googleMapsApiKey}`;
    
    // Option 2: Call your NestJS backend (recommended)
    const url = `${environment.apiUrl}/google-reviews/${this.PLACE_ID}`;
    return this.http.get<PlaceDetails>(url).pipe(
      map(response => {
        if (response.status === 'OK' && response.result.reviews) {
          // Filter only 4+ star reviews and sort by rating
          return response.result.reviews
            .filter(review => review.rating >= 4)
            .sort((a, b) => b.rating - a.rating);
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching Google reviews:', error);
        // Return mock data for development/testing
        return of(this.getMockReviews());
      })
    );
  }

  /**
   * Mock reviews for development/testing
   */
  private getMockReviews(): GoogleReview[] {
    return [
      {
        author_name: "John Smith",
        author_url: "#",
        language: "en",
        profile_photo_url: "https://lh3.googleusercontent.com/a/default-user=s128-c0x00000000-cc-rp-mo",
        rating: 5,
        relative_time_description: "a week ago",
        text: "Excellent service! They fixed my car quickly and the price was very reasonable. The staff was friendly and explained everything clearly.",
        time: Date.now() - 604800000
      },
      {
        author_name: "Sarah Johnson",
        author_url: "#",
        language: "en",
        profile_photo_url: "https://lh3.googleusercontent.com/a/default-user=s128-c0x00000000-cc-rp-mo",
        rating: 5,
        relative_time_description: "2 weeks ago",
        text: "Best mechanic in town! They diagnosed the problem immediately and had my car running perfectly. Highly recommend!",
        time: Date.now() - 1209600000
      },
      {
        author_name: "Mike Davis",
        author_url: "#",
        language: "en",
        profile_photo_url: "https://lh3.googleusercontent.com/a/default-user=s128-c0x00000000-cc-rp-mo",
        rating: 4,
        relative_time_description: "a month ago",
        text: "Great experience overall. The work was done well and on time. Prices are fair for the quality of service.",
        time: Date.now() - 2592000000
      }
    ];
  }
}